import { Box, Stack } from '@atlaskit/primitives';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CATEGORIES } from '../components/menu-page/CategorySidebar';
import { AnnouncementCoreData } from './announcements';
import { messages } from './messages';
import contextMenuGif from '../assets/images/context_menu.gif';

const ContextMenuAnnouncement = (): React.JSX.Element => (
	<Box>
		<Box>
			<FormattedMessage {...messages.contextMenuIntro} />
		</Box>
		<Stack as="ul" space="space.100">
			<li>
				<b>
					<FormattedMessage {...messages.contextMenuAutomateTitle} />
				</b>{' '}
				<FormattedMessage {...messages.contextMenuAutomateDesc} />
			</li>
			<li>
				<b>
					<FormattedMessage {...messages.contextMenuFlowTitle} />
				</b>{' '}
				<FormattedMessage {...messages.contextMenuFlowDesc} />
			</li>
		</Stack>
		<Box paddingBlockStart="space.200">
			<b>
				<FormattedMessage {...messages.contextMenuHowToUseHeading} />
			</b>
			<Stack as="ol" space="space.100">
				<li>
					<FormattedMessage {...messages.contextMenuHowToUseStep1} />
				</li>
				<li>
					<FormattedMessage {...messages.contextMenuHowToUseStep2} />
				</li>
			</Stack>
		</Box>
	</Box>
);

export const ContextMenuAnnouncementData: AnnouncementCoreData = {
	title: messages.contextMenuTitle.defaultMessage,
	content: <ContextMenuAnnouncement />,
	tags: [CATEGORIES.EXTENSION],
	media: {
		type: 'image',
		url: { default: contextMenuGif },
		alt: messages.contextMenuGifAlt.defaultMessage,
	},
};

export default ContextMenuAnnouncement;
